import React from "react";
import styles from "./TableToolbar.module.scss";

/**
 * Liste sayfası toolbar'ı — başlık + tab navigasyonu + arama + filtreler +
 * view switcher + sağ aksiyonlar.
 *
 * Sözleşme (Calendar feature CalendarToolbar pattern'inden adapte —
 * de-Bootstrap kampanyası Faz 8 merkezileştirme review):
 *
 * <TableToolbar
 *   title="Tasks"
 *   tabs={[{ value, label, count? }]}
 *   activeTab={...}
 *   onTabChange={...}
 *   leftSlot={<SearchInput />}         // alt satır sol — opsiyonel
 *   filtersSlot={<FilterDropdowns />}  // alt satır sağ — opsiyonel
 *   viewSlot={<ViewSwitcher />}        // üst satır sağ grup, actions'ın
 *                                      // SOLUNDA (kullanıcı talebi).
 *   actions={<><IconButton .../></>}   // üst satır sağ grup, en sağda
 * />
 *
 * Subtitle bilinçli olarak desteklenmez — kullanıcı kararı: liste
 * sayfalarında açıklama metni gürültü yaratıyor; başlık + tab seti
 * sayfa amacını zaten netler.
 */
const TableToolbar = ({
  title,
  tabs,
  activeTab,
  onTabChange,
  leftSlot,
  filtersSlot,
  viewSlot,
  actions,
}) => {
  const hasBottomRow = !!(leftSlot || filtersSlot);

  return (
    <div className={styles.toolbar}>
      <div className={styles.topRow}>
        <div className={styles.titleBlock}>
          {title ? <h1 className={styles.title}>{title}</h1> : null}
          {tabs && tabs.length > 0 ? (
            <div
              className={styles.tabs}
              role="tablist"
              aria-label="Görünüm sekmeleri"
            >
              {tabs.map((t) => (
                <button
                  key={t.value}
                  type="button"
                  role="tab"
                  aria-selected={activeTab === t.value}
                  data-active={activeTab === t.value || undefined}
                  className={styles.tab}
                  onClick={() => onTabChange?.(t.value)}
                >
                  <span className={styles.tabLabel}>{t.label}</span>
                  {t.count != null ? (
                    <span className={styles.tabCount}>{t.count}</span>
                  ) : null}
                </button>
              ))}
            </div>
          ) : null}
        </div>

        {(viewSlot || actions) && (
          <div className={styles.rightCluster}>
            {viewSlot ? <div className={styles.viewSlot}>{viewSlot}</div> : null}
            {actions ? <div className={styles.actions}>{actions}</div> : null}
          </div>
        )}
      </div>

      {hasBottomRow ? (
        <div className={styles.bottomRow}>
          <div className={styles.bottomLeft}>{leftSlot}</div>
          <div className={styles.bottomRight}>{filtersSlot}</div>
        </div>
      ) : null}
    </div>
  );
};

export default TableToolbar;
